// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3S3oQ","title":"style_title__CkcaG","note":"style_note__Nmpmm","group":"style_group__1LKhy"};